import index from '../components/index';
import status from '../components/status';

export default [
    {
        component:index,
        name:'applications',
        path:'/applications',
        meta: { auth: true },
    },
    {
        component:status,
        name:'status',
        path:'/status',
        meta: { auth: true },
    },
]